module.exports = __webpack_public_path__ + "static/929537264.ecb1b079.jpg";